/*
 * @Descripttion: 德运通天然气管理系统
 * @version: 1.0.0
 * @Author: xst
 * @Date: 2020-03-31 13:00:48
 * @LastEditors: xst
 * @LastEditTime: 2020-06-30 09:32:40
 */
import en from "../i18n/lang/en";
import cn from "../i18n/lang/cn";
import Vue from "vue";
import Router from "vue-router";
import Login from "@/pages/login/index";
import imageView from "@/pages/login/imageView";
import Layout from "@/pages/layout/layout";
import HomeMain from "@/pages/index/mainIndex";
import imgDownload from "@/pages/reimburse/components/imgDownload";

// 不是必须加载的组件使用懒加载
const NotFound = () => import("@/page404");
const quickKey = () => import("@/pages/login/quickKey");

const contract = () => import("@/pages/myContract/contract");
const contractMould = () => import("@/pages/myContract/contractMould");
const newsupply = () => import("@/pages/myContract/newsupply");
const pending = () => import("@/pages/myContract/pending");
const contractIndex = () => import("@/pages/myContract/contractIndex");
const newcontract = () => import("@/pages/myContract/newcontract");
const checkcontract = () => import("@/pages/myContract/checkcontract");
const copyContract = () => import("@/pages/myContract/copyContract");
const remind = () => import("@/pages/myContract/remind");
const adjustmentList = () => import("@/pages/myContract/adjustmentList");
const newadjustment = () => import("@/pages/myContract/newadjustment");
const purchaseContract=()=>import("@/pages/myContract/purchaseContract");
const transportContractList = () => import("@/pages/myContract/transportContractList");

const dailyCompute = () => import("@/pages/dailyListing/dailyCompute");
const newDaily = () => import("@/pages/dailyListing/newDaily");
const day = () => import("@/pages/dailyListing/day");


const appVersion = () => import("@/pages/information/appVersion");
// const shiYan = () => import("@/pages/information/shiYan");
const companyList = () => import("@/pages/information/companyList");
const organizetion=()=>import("@/pages/information/organizetion");
const roleList = () => import("@/pages/information/roleList");
const staffList = () => import("@/pages/information/staffList");
const accountList = () => import("@/pages/information/accountList");
const websiteList = () => import("@/pages/information/websiteList");
const gasList=()=>import("@/pages/information/gasList");
const loadList=()=>import("@/pages/information/loadList");
const baseset = () => import("@/pages/information/baseSet");
const tagList = () => import("@/pages/information/tagList");
const cylindermanage = () =>import("@/pages/information/cylinderList");
const gasificationList = () => import("@/pages/information/gasification/list");
// 运输基础
const driverList = () => import("@/pages/information/driverList");
const carTypeList = () => import("@/pages/information/carTypeList");
const carSet = () => import("@/pages/information/carSet");
const ETCList = () => import("@/pages/information/ETCList");
const ETCTradeList = () => import("@/pages/information/ETCTradeList");
const fuelCardList = () => import("@/pages/information/fuelCardList");
const fuelCardTradeList = () => import("@/pages/information/fuelCardTradeList");
const otherFeeList = () => import("@/pages/information/otherFeeList");
const distanceList=()=>import("@/pages/transport/distanceList")
const gasPriceList = () => import("@/pages/information/gasPriceList");
const oilPriceList = () => import("@/pages/information/oilPriceList");
const roleAuthorize = () => import("@/pages/information/components/roleAuthorize");

const handoverList = () => import("@/pages/handover/list");
const Page300 = () => import("@/pages/error/300");
const addAndEditContract = () => import("@/pages/myContract/components/addAndEditContract.vue");

const mySell = () => import("@/pages/sell/mySell");
const sellList = () => import("@/pages/sell/sellList");
const changeSupplyWay = () => import("@/pages/sell/changeSupplyWay");
const innerCheckList = () => import("@/pages/sell/innerCheckList");
const newSellGaugeTicket = () => import("@/pages/sell/newSellGaugeTicket");
const meterReading=()=>import("@/pages/sell/meterReading");
const sellGaugeTicketList = () => import("@/pages/sell/sellGaugeTicketList");
const errorSellList = () => import("@/pages/sell/errorSellList");
const flowmeterPrint = () => import("@/pages/sell/components/flowmeterPrint");
const fillingVolumePrint = () => import("@/pages/sell/components/fillingVolumePrint");
const loadingAndUnloadingPrint = () => import("@/pages/sell/components/loadingAndUnloadingPrint");
const specsPrint = () => import("@/pages/sell/components/specsPrint");
const weightPrint = () => import("@/pages/sell/components/weightPrint");

const closingAccounts = () => import("@/pages/settlement/closingAccounts");
const executionClause = () => import("@/pages/settlement/executionClause");

const invoice = () => import("@/pages/settlement/invoice");
const beinvoice = () => import('@/pages/settlement/beinvoice');
const metering = () => import("@/pages/settlement/metering");
const otherExpenses = () => import("@/pages/settlement/otherExpenses");
const receivableList=()=>import("@/pages/settlement/receivableList");
const mySettlement = () => import("@/pages/settlement/mySettlement");
const unusualMetering = () => import("@/pages/settlement/unusualMetering");
const compareData = () => import("@/pages/settlement/compareData");

const settlementflowmeterPrint = () => import("@/pages/settlement/components/flowmeterPrint");
const settlementfillingVolumePrint = () => import("@/pages/settlement/components/fillingVolumePrint");
const settlementloadingAndUnloadingPrint = () => import("@/pages/settlement/components/loadingAndUnloadingPrint");
const settlementspecsPrint = () => import("@/pages/settlement/components/specsPrint");
const settlementweightPrint = () => import("@/pages/settlement/components/weightPrint");
const settlementAllPrint = () => import("@/pages/settlement/components/allPrint");
const adjustPrint = () => import("@/pages/myContract/components/adjustprint");
const checkDraftApplyPrint = () => import("@/pages/fund/draft/components/checkDraftApplyPrint.vue");
/*贸易 start*/
const riskControl = () => import("@/pages/riskControl/riskControlIndex");
const collectionList = () => import("@/pages/trade/collectionList");

const companyPolicy=()=>import("@/pages/innerCash/companyPolicy");
const purchasePrice=()=>import("@/pages/innerCash/purchasePrice");
const groupPurchase=()=>import("@/pages/innerCash/groupPurchase");
const innerPrice=()=>import("@/pages/innerCash/innerPrice");
const innerForm=()=>import("@/pages/innerCash/innerForm");
const compareForm=()=>import("@/pages/innerCash/compareForm");
const fixedTrack=()=>import("@/pages/innerCash/fixedTrack");
const reject=()=>import("@/pages/innerCash/reject");
const standardFreightList=()=>import("@/pages/innerCash/standardFreightList");
const innerPriceHistoryList=()=>import("@/pages/innerCash/innerPriceHistoryList");
const purchasePriceAnalysis=()=>import("@/pages/innerCash/purchasePriceAnalysis");
const lCngChargeList = () => import("@/pages/innerCash/lCngCharge/list");

const tradeRuleList = () => import("@/pages/tradeManagement/tradeRule/tradeRuleList.vue");
const tradeCustomerList = () => import("@/pages/tradeManagement/tradeCustomer/tradeCustomerList.vue");
const myTrade = () => import("@/pages/tradeManagement/myTrade/myTrade.vue");
const tradeContract = () => import("@/pages/myContract/tradeContract.vue");
const priceConfirm = () => import("@/pages/tradeManagement/priceConfirm/priceConfirm.vue");
const tradeDemand = () => import("@/pages/tradeManagement/tradeDemand/tradeDemand.vue");
const tradeSale = () => import("@/pages/tradeManagement/tradeSale/tradeSale.vue");
const tradeCollection=()=>import("@/pages/tradeManagement/tradeCollection/tradeCollection.vue");
const tradeCheckAmount = ()=> import("@/pages/tradeManagement/tradeCheckAmount/tradeCheckAmount.vue");
const tradeSettle = () => import("@/pages/tradeManagement/tradeSettle/tradeSettle.vue");
const priceConfirmPrint = () => import("@/pages/tradeManagement/priceConfirm/priceConfirmPrint");
const tradeSettlePrint = () => import("@/pages/tradeManagement/tradeSettle/tradeSettlePrint");
/*利润统计*/
const profitStatistics=()=>import("@/pages/tradeProfitShare/profitStatisticsList");
const profitRule=()=>import("@/pages/tradeProfitShare/profitRuleList");
const customerRebate=()=>import("@/pages/tradeProfitShare/customerRebateList");
const businessBx=()=>import("@/pages/tradeProfitShare/businessBxList");
const rewardRuleList=()=>import("@/pages/tradeProfitShare/rewardRuleList");
const awardIssueRuleList=()=>import("@/pages/tradeProfitShare/awardIssueRuleList");
const staffRoleList=()=>import("@/pages/tradeProfitShare/staffRoleList");
const salesRewardDetailList=()=>import("@/pages/tradeProfitShare/salesRewardDetailList");
const otherRewardDetailList=()=>import("@/pages/tradeProfitShare/otherRewardDetailList");
const awardIssueDetailList=()=>import("@/pages/tradeProfitShare/awardIssueDetailList");


/*贸易 end*/
const mypurchasel=()=>import("@/pages/myPurchase/mypurchasel")
const purchasePlanH=()=>import("@/pages/myPurchase/purchasePlanH")
const newPlan=()=>import("@/pages/myPurchase/newPlan")
const purchasePlanL=()=>import("@/pages/myPurchase/purchasePlanL")
const newGasPlan=()=>import("@/pages/myPurchase/newGasPlan")
const orders=()=>import("@/pages/myPurchase/orders");
const ordersettle=()=>import("@/pages/myPurchase/ordersettle");
const orderinvoice=()=>import("@/pages/myPurchase/orderinvoice");
const orderaccount=()=>import("@/pages/myPurchase/orderaccount");
const orderform=()=>import("@/pages/myPurchase/orderform");
const supplierbuget=()=>import("@/pages/myPurchase/supplierbuget");
const paybuget=()=>import("@/pages/myPurchase/paybuget");
const errororders=()=>import("@/pages/myPurchase/errororders");
const checkAmount=()=>import("@/pages/myPurchase/checkAmount/list");
const purchasePay=()=>import("@/pages/myPurchase/pay/list");
const purchaseSettle=()=>import("@/pages/myPurchase/settle/list");
const settlePrintPurchase = () => import("@/pages/myPurchase/settle/components/print");

const preferentialClauseList=()=>import("@/pages/myPurchase/preferentialClause/list");
const priceConfirmList=()=>import("@/pages/myPurchase/priceConfirm/list");
const purchaseList=()=>import("@/pages/myPurchase/purchase/list");
const changeSettleAmountList=()=>import("@/pages/myPurchase/changeSettleAmount/list");


/*贸易 end*/
const adjustPrice=()=>import("@/pages/myPurchase/adjustPrice");
const subcompanyPlan=()=>import("@/pages/myPurchase/subcompanyPlan/list");
const arrangePurchasingPlan=()=>import("@/pages/myPurchase/arrangePurchasingPlan/list");
const batchConfirm=()=>import("@/pages/myPurchase/batchConfirm/add");


const taskList = () => import("@/pages/transport/taskList");
const newTransport = () => import("@/pages/transport/newTransport");
const newTrance = () => import("@/pages/transport/newTrance");
const transportList = () => import("@/pages/transport/transportList");
const transportCheckList = () => import("@/pages/transport/transportCheckList");
const checkAmountList = () => import("@/pages/transport/checkAmountList");
const transportPay=() =>import("@/pages/transport/transportPay");
const checkMoneyList = () => import("@/pages/transport/checkMoneyList");

const tollList=()=>import("@/pages/transport/tollList");
const saturation=()=>import("@/pages/transport/saturation");
const saturationprint=()=>import("@/pages/transport/components/saturationprint");
const saturationDetailPrint=()=>import("@/pages/transport/components/saturationDetailPrint")
const transportPrint = () => import("@/pages/transport/components/transportPrint");
const loadUnloadList = () => import("@/pages/transport/loadUnloadList");
const familyFeeList = () => import("@/pages/transport/familyFeeList");
const gasPriceComputer = () => import("@/pages/transport/gasPriceComputer");
const myTransport = () => import("@/pages/transport/myTransport");
const carTransportReport = () => import("@/pages/transport/carTransportReport");
const twoInvoiceTransportReport = () => import("@/pages/transport/twoInvoiceTransportReport");
const transportCheckReport = () => import("@/pages/transport/transportCheckReport");
const errorTransportList = () => import("@/pages/transport/errorTransportList");
/*绩效管理*/
const performanceRank = () => import("@/pages/performance/performanceRank");
const performIndex=()=>import("@/pages/performance/performIndex");
const performRule=()=>import("@/pages/performance/performRule");
const workOrder=()=>import("@/pages/performance/workOrder")
const personPointDetail = () => import("@/pages/performance/personPointDetail");
const decutePointRule = () => import("@/pages/performance/decutePointRule/decutePointRuleList");
const examItemList = () => import("@/pages/performance/examItem/examItemList");
const siteVisit = () => import("@/pages/performance/siteVisit");
/*绩效管理*/

/*利润分析开始*/
const pointCost=()=>import("@/pages/profitability/pointCost/index");
const fixedAssets=()=>import("@/pages/profitability/fixedAssets/index");
const ratioAnalysis =()=>import("@/pages/profitability/ratioAnalysis/index");
const manageRate=()=>import("@/pages/profitability/manageRate/index");
const benefitsList=()=>import("@/pages/profitability/benefitsList/index");
const projectBenefits=()=>import("@/pages/profitability/projectBenefits/index");

/*利润分析结束*/
/*资金管理start*/
const config = () => import("@/pages/fund/config");
const transferUnit = () => import("@/pages/fund/transferUnit");
const transferAccount = () => import("@/pages/fund/transferAccount");

const subject = () => import("@/pages/fund/subject");
const invoiceNew = () => import("@/pages/fund/invioceNew");
const invoiceApply = () => import("@/pages/fund/invioceApply");
const draft = () => import("@/pages/fund/draft");
const draftCollect = () => import("@/pages/fund/draft/collectDraft");
const discount = () => import("@/pages/fund/draft/discount");
const transferOrder = () => import("@/pages/fund/transferOrder");
const payApproveOrder = () => import("@/pages/fund/payApproveOrder");
const accountBalance = () => import("@/pages/fund/relateSearch/accountBalance");
const receiveMoney = () => import("@/pages/fund/relateSearch/receiveMoney");
const payMoney = () => import("@/pages/fund/relateSearch/payMoneySearch");
const circleStartBalance = () => import("@/pages/fund/relateSearch/circleStartBalance");
const payApproveOrderPrint = () => import("@/pages/fund/payApproveOrder/components/payApproveOrderPrint");
const virtualAccount = () => import("@/pages/fund/virtualAccount");
const transferVirtual = () => import("@/pages/fund/transferVirtual");
/*资金管理end*/
/*应收应付start*/
const purchaseReport = () => import("@/pages/receiveAndPay/purchaseReport");
const transportReport = () => import("@/pages/receiveAndPay/transportReport");
const sellReport = () => import("@/pages/receiveAndPay/sellReport");
const purchaseEstimate = () => import("@/pages/receiveAndPay/purchaseEstimate");
const transportEstimate = () => import("@/pages/receiveAndPay/transportEstimate");
const sellEstimate = () => import("@/pages/receiveAndPay/sellEstimate");
const sellStand = () => import("@/pages/receiveAndPay/sellStand");
const purchaseStand = () => import("@/pages/receiveAndPay/purchaseStand");
const transportStand = () => import("@/pages/receiveAndPay/transportStand");
const supplyNeedPay = () => import("@/pages/receiveAndPay/supplyNeedPay");
const transportNeedPay = () => import("@/pages/receiveAndPay/transportNeedPay");
const curstomerNeedReceive = () => import("@/pages/receiveAndPay/curstomerNeedReceive");
const myReceiveAndPay = () => import("@/pages/receiveAndPay/myReceiveAndPay");
const closingAcount = () => import("@/pages/receiveAndPay/closingAcount");
const needPayTax = () => import("@/pages/receiveAndPay/needPayTax");
const beReceiveInvoice = () => import("@/pages/fund/receiveTicketList/beReceiveInvoice");
/*应收应付end*/

/*工具箱*/
const LNGProposal = () => import("@/pages/tools/LNGProposal");
const newBattlePlan = () => import("@/pages/tools/newBattlePlan");
const statisticsPlan = () => import("@/pages/tools/statisticsPlan");
/*钢瓶管理*/
const scanRecord = () => import("@/pages/cylinder/scanRecord");
const cylinderTagList = () => import("@/pages/cylinder/cylinderTagList");
const cylinderContainer = () => import("@/pages/cylinder/cylinderContainer");
const cylinderList = () => import("@/pages/cylinder/cylinderList");
const truckRecord = () => import("@/pages/cylinder/truckRecord");

/*充装*/
const chargeList = () => import("@/pages/myCharge/charge/list");
const checkChargeList = () => import("@/pages/myCharge/checkCharge/list");

/*钢瓶管理*/
const weeklyCollectionStaticsList = () => import("@/pages/statics/weeklyCollectionStatics/list");
/*报表管理cng+Lng*/
const cngReport = () => import("@/pages/statics/cng/list");
const lngReport = () => import("@/pages/statics/lng/list");
// const NotFound = () => import('@/page404')

/*其他业务 - 流转*/
const circulationList = () => import("@/pages/otherBusiness/circulation/list");
const circulationAdd = () => import("@/pages/otherBusiness/circulation/add");
/*欠费申请*/

const oweApplyList = () => import("@/pages/settlement/oweApplyList");

/*其他业务 - 非标流程*/
const specialProcessPurchaseList = () => import("@/pages/otherBusiness/specialProcessPurchase/list");
/*其他业务 - 南通扬州用气量单价配置*/
const gasUseAndPrice = () => import("@/pages/myPurchase/gasUseAndPrice/index");
/*lng出入库*/
const lngInOutBase = () => import("@/pages/myPurchase/lngInOutBase/index");

/*报销管理 start*/
const reimburseManagement = () => import("@/pages/reimburse/reimburseManagement/index");
const indexStaff = () => import("@/pages/reimburse/reimburseManagement/indexStaff");
const reimbursementSummary = () => import("@/pages/reimburse/reimbursementSummary");
const reimbursementStatistics = () => import("@/pages/reimburse/reimbursementStatistics");
const reimbursementType = () => import("@/pages/reimburse/reimbursementType");
const printReimburse = () => import("@/pages/reimburse/reimburseManagement/components/printReimburse");
/*报销管理 end*/
/*工资管理start*/
const individualIncomeTaxLevel = () => import("@/pages/salaryManagement/individualIncomeTaxLevel/index");
const floatingSalaryType = () => import("@/pages/salaryManagement/floatingSalaryType/index");
const socialSecurityInformation = () => import("@/pages/salaryManagement/socialSecurityInformation/index");
const personnelSalaryInformation = () => import("@/pages/salaryManagement/personnelSalaryInformation/index");
const floatingSalary = () => import("@/pages/salaryManagement/floatingSalary/index");
const salaryDetails = () => import("@/pages/salaryManagement/salaryDetails/index");
const salaryAdjustment = () => import("@/pages/salaryManagement/salaryAdjustment/index");
const salarySummary = () => import("@/pages/salaryManagement/salarySummary/index");
const attendanceSummary = () => import("@/pages/salaryManagement/attendanceSummary/index");
/*工资管理end*/

/*气款管理 start*/
const gasPaymentApplication = () => import("@/pages/gasManagement/gasPaymentApplication/index");
const estimatedCost = () => import("@/pages/gasManagement/estimatedCost/index");
/*气款管理 end*/

/*绩效考核 start*/
const assessmentCoefficient = () => import("@/pages/performanceAppraisal/assessmentCoefficient/index");
const assessmentItems = () => import("@/pages/performanceAppraisal/assessmentItems/index");
const assessmentRole = () => import("@/pages/performanceAppraisal/assessmentRole/index");
const levelConfiguration = () => import("@/pages/performanceAppraisal/levelConfiguration/index");
const assessmentObject = () => import("@/pages/performanceAppraisal/assessmentObject/index");
const examinationTableMonth = () => import("@/pages/performanceAppraisal/examinationTableMonth/index");
const examinationTableYear = () => import("@/pages/performanceAppraisal/examinationTableYear/index");
const monthlyTaskDashboard = () => import("@/pages/performanceAppraisal/monthlyTaskDashboard/index");
const annualTaskDashboard = () => import("@/pages/performanceAppraisal/annualTaskDashboard/index");
const performanceStatistics = () => import("@/pages/performanceAppraisal/performanceStatistics/index");
const assessmentDataInput = () => import("@/pages/performanceAppraisal/assessmentDataInput/index");
/*绩效考核 end*/

Vue.use(Router);

let routeName = en.routeName;
let defaultRouter = [
  {
    path: "/",
    redirect: "/index",
    hidden: true,
    children: []
  },
  {
    path: '/Hub',
    name: 'hub',
    hidden: true,
    component: resolve => require (['@/pages/Hub.vue'], resolve),
    children: []
  },
  {
    path: "/login",
    component: Login,
    name: "",
    hidden: true,
    children: []
  },
  {
    path: "/imageView",
    component: imageView,
    name: "",
    hidden: true,
    children: []
  },
  {
    path: "/imgDownload",
    component: imgDownload,
    name: "",
    hidden: true,
    children: []
  },
  {
    path: "/statisticsPlanOther",
    component: statisticsPlan,
    name: "",
    hidden: true,
    children: []
  },
  {
    path: "/index",
    iconCls: "fa fa-dashboard", // 图标样式class
    name: routeName.home,
    component: Layout,
    alone: true,
    children: [
      {
        path: "/index",
        iconCls: "fa fa-dashboard", // 图标样式class
        name: "主页",
        component: HomeMain,
        children: []
      }
    ]
  },
  {
    path: "/404",
    component: NotFound,
    name: "404",
    hidden: true,
    children: []
  },
  {
    path: "/flowmeterPrint",
    name: 'fillingVolumePrint',//销售计量单打印--流量计
    component: flowmeterPrint,
    hidden: true,
    children: []
  },
  {
    path: "/fillingVolumePrint",
    name: 'fillingVolumePrint',//销售计量单打印--充装量
    component: fillingVolumePrint,
    hidden: true,
    children: []
  },
  {
    path: "/loadingAndUnloadingPrint",
    name: 'loadingAndUnloadingPrint',//销售计量单打印--装卸车
    component: loadingAndUnloadingPrint,
    hidden: true,
    children: []
  },
  {
    path: "/specsPrint",
    name: 'specsPrint',//销售计量单打印--规格
    component: specsPrint,
    hidden: true,
    children: []
  },
  {
    path: "/weightPrint",
    name: 'weightPrint',//销售计量单打印--重量
    component: weightPrint,
    hidden: true,
    children: []
  },
  /*结算单 打印 模板 start*/

  {
    path: "/weightPrint",
    name: 'weightPrint',//销售计量单打印--重量
    component: weightPrint,
    hidden: true,
    children: []
  },

  {
    path: "/settlementflowmeterPrint",
    name: '计量结算单打印-流量计',//销售计量单打印--流量计
    component: settlementflowmeterPrint,
    hidden: true,
    children: []
  },
  {
    path: "/settlementfillingVolumePrint",
    name: '计量结算单打印-充装量',//销售计量单打印--充装量
    component: settlementfillingVolumePrint,
    hidden: true,
    children: []
  },
  {
    path: "/settlementloadingAndUnloadingPrint",
    name: '计量结算单打印-装卸车',//销售计量单打印--装卸车
    component: settlementloadingAndUnloadingPrint,
    hidden: true,
    children: []
  },
  {
    path: "/settlementspecsPrint",
    name: '计量结算单打印-规格',//销售计量单打印--规格
    component: settlementspecsPrint,
    hidden: true,
    children: []
  },
  {
    path: "/settlementweightPrint",
    name: '计量结算单打印-重量',//销售计量单打印--重量
    component: settlementweightPrint,
    hidden: true,
    children: []
  },
  {
    path: "/settlementAllPrint",
    name: '计量结算单合并打印',//所有类型的打印，用于批量合并打印
    component: settlementAllPrint,
    hidden: true,
    children: []
  },
  /*结算单 打印 模板 end*/
  {
    path: "/settlePrintPurchase",
    name: '采购结算单打印',//
    component: settlePrintPurchase,
    hidden: true,
    children: []
  },
  /*付款申请单打印*/
  {
    path: "/payApproveOrderPrint",
    name: '付款申请单打印',//付款申请单打印
    component: payApproveOrderPrint,
    hidden: true,
    children: []
  },
  {
    path: "/checkDraftApplyPrint",
    name: '托收申请打印',//托收申请打印
    component: checkDraftApplyPrint,
    hidden: true,
    children: []
  },
  {
    path: "/adjustPrint",
    name: 'adjustPrint',//调价函打印
    component: adjustPrint,
    hidden: true,
    children: []
  },
  {
    path: "/adjustPrint",
    name: 'adjustPrint',//调价函打印
    component: adjustPrint,
    hidden: true,
    children: []
  },
  {
    path: "/page300",
    component: Page300,
    name: "page300",
    hidden: true,
    children: []
  },
  {
    path: "/quickKey",
    component: quickKey,
    name: "quickKey",
    hidden: true,
    children: []
  },
  /*运输结算单 打印 模板 end*/
  {
    path: "/transportPrint",
    component: transportPrint,
    name: "transportPrint",
    hidden: true,
    children: []
  },
  /*贸易start*/
  {
    path: "/priceConfirmPrint",
    component: priceConfirmPrint,
    name: "priceConfirmPrint",
    hidden: true,
    children: []
  },
  {
    path: "/tradeSettlePrint",
    component: tradeSettlePrint,
    name: "tradeSettlePrint",
    hidden: true,
    children: []
  },
  /*贸易end*/
  /*报销单打印*/
  {
    path: "/printReimburse",
    name: '报销单打印',//报销单打印
    component: printReimburse,
    hidden: true,
    children: []
  },
];

let addRouter = [
  {
    key: "1",
    path: "/",
    iconCls: "el-icon-deytjichuxinxiguanli1", // 图标样式class
    name: routeName.imformation,
    component: Layout,
    children: [

      {
        key: "1-121",
        path: "/appVersion",
        iconCls: "el-icon-eleme", // 图标样式class
        name: routeName.appVersion,//app版本管理
        component: appVersion,
        children: []
      },
      {
        key: "1-1",
        path: "/companyList",
        iconCls: "el-icon-deytgongsi2", // 图标样式class
        name: routeName.companyList,//公司列表
        component: companyList,
        children: []
      },
      // {
      //   key: "1-1",
      //   path: "/shiYan",
      //   iconCls: "el-icon-deytgongsi2", // 图标样式class
      //   name: routeName.shiYan,//公司列表
      //   component: shiYan,
      //   children: []
      // },
      {
        key: "1-199",
        path: "/organizetion",
        iconCls: "el-icon-deytgongsi2", // 图标样式class
        name: routeName.organizetion,//公司列表
        component: organizetion,
        children: []
      },
      {
        key: "1-2",
        path: "/roleList",
        iconCls: "el-icon-deytkerenxinxiguanli1", // 图标样式class
        name: routeName.roleList,//角色
        component: roleList,
        children: []
      },

      {
        key: "1-3",
        path: "/staffList",
        iconCls: "el-icon-deytyewurenyuanxinxiguanli", // 图标样式class
        name: routeName.staffList,//人员
        component: staffList,
        children: []
      },
      {
        key: "1-4",
        path: "/accountList",
        iconCls: "el-icon-deytfenghuangxiangmutubiao_quanxian", // 图标样式class
        name: routeName.accountList,//账户
        component: accountList,
        children: []
      },
      {
        key: "1-14",
        path: "/handoverList",
        iconCls: "el-icon-deytbiaoxinxiguanli", // 图标样式class deytbiaoxinxiguanli
        name: routeName.handoverList,
        component: handoverList,//交割点
        children: []
      },
      {
        key: "1-22",
        path: "/websiteList",
        iconCls: "el-icon-deytxiangmujiesuanbaobiao", // 图标样式class
        name: routeName.websiteList,
        component: websiteList,//站点
        children: []
      },
      {
        key: "1-73",
        path: "/gasList",
        iconCls: "el-icon-deytqiya", // 图标样式class
        name: routeName.gasList,
        component: gasList,//气源
        children: []
      },
      {
        key: "1-143",
        path: "/loadList",
        iconCls: "el-icon-deytyoudi", // 图标样式class
        name: routeName.loadList,
        component: loadList,//气源
        children: []
      },
      {
        key: "1-35",
        path: "/baseset",
        iconCls: "el-icon-deyticon_xinyong_xianxing_jijin-", // 图标样式class
        name: routeName.baseset,
        component: baseset,//基础开关配置
        children: []
      },
      {
        key: "1-35",
        path: "/roleAuthorize",
        iconCls: "el-icon-deyticon_xinyong_xianxing_jijin-", // 图标样式class
        name: routeName.roleAuthorize,
        component: roleAuthorize,//数据角色授权
        hidden:true,
        children: []
      },
      {
        key: "24-195",
        path: "/gasificationList",
        iconCls: "el-icon-deyticon_xinyong_xianxing_jijin-", // 图标样式class
        name: routeName.gasificationList,
        component: gasificationList,//LNG氣化率基礎管理
        children: []
      },
      {
        key: "1-35",
        path: "/tagList",
        iconCls: "el-icon-deyticon_xinyong_xianxing_jijin-", // 图标样式class
        name: routeName.tagList,
        component: tagList,//标签管理
        children: []
      },
      {
        key: "1-129",
        path: "/config",
        name: routeName.baseConfig,
        component: config,//字典项配置
        children: []
      },
      {
        key: "1-130",
        path: "/transferUnit",
        name: routeName.transferUnit,
        component: transferUnit,//往来单位
        children: []
      },
      {
        key: "1-131",
        path: "/transferAccount",
        name: routeName.transferAccount,
        component: transferAccount,//往来账户
        children: []
      },

    ]
  },
  {
    key: "16",
    path: "/",
    iconCls: "el-icon-deythuiyuanzuanshi-xianxing", // 图标样式class
    name: routeName.performance,//绩效管理
    component: Layout,
    children: [
      /*{
        key: "16-113",
        path: "/performanceRank",
        iconCls: "el-icon-deytpaiming", // 图标样式class
        name: routeName.performanceRank,//绩效排名
        component: performanceRank,
        children: []
      },
      {
        key: "16-114",
        path: "/performIndex",
        iconCls: "el-icon-deytzhibiao1", // 图标样式class
        name: routeName.performIndex,//考核指标
        component: performIndex,
        children: []
      },
      {
        key: "16-115",
        path: "/performRule",
        iconCls: "el-icon-deytguizedingyix", // 图标样式class
        name: routeName.performRule,//考核规则
        component: performRule,
        children: []
      },
      {
        key: "16-118",
        path: "/personPointDetail",
        iconCls: "el-icon-deytyuangongshouye-gerenjixiao", // 图标样式class
        name: routeName.personPointDetail,//个人绩效扣分明细
        component: personPointDetail,
        children: []
      },
      {
        key: "16-116",
        path: "/decutePointRule",
        iconCls: "el-icon-deytfenshu", // 图标样式class
        name: routeName.decutePointRule,//扣分规则列表
        component: decutePointRule,
        children: []
      },
      {
        key: "16-117",
        path: "/examItemList",
        iconCls: "el-icon-deyticon-project", // 图标样式class
        name: routeName.examItemList,//考核项列表
        component: examItemList,
        children: []
      },*/
      {
        key: "16-119",
        path: "/workOrder",
        iconCls: "el-icon-deytgongdan", // 图标样式class
        name: routeName.workOrder,//工单管理
        component: workOrder,
        children: []
      },
      {
        key: "16-230",
        path: "/siteVisit",
        iconCls: "el-icon-deytfenshu", // 图标样式class
        name: routeName.siteVisit,//站点访问统计
        component: siteVisit,
        children: []
      },

    ]
  },
   // 绩效考核start
  {
    key: "31",
    path: "/",
    iconCls: "el-icon-deytjixiaoguanli", // 图标样式class
    name: routeName.performanceAppraisal,//绩效考核
    component: Layout,
    children: [
      {
        key: "31-254",
        path: "/levelConfiguration",
        iconCls: "el-icon-deytpaiming", // 图标样式class
        name: routeName.levelConfiguration,//等级配置
        hidden: true,
        component: levelConfiguration,
        children: []
      },
      {
        key: "31-255",
        path: "/assessmentCoefficient",
        iconCls: "el-icon-deytpaiming", // 图标样式class
        name: routeName.assessmentCoefficient,//考核系数
        component: assessmentCoefficient,
        hidden: true,
        children: []
      },
      {
        key: "31-256",
        path: "/assessmentItems",
        iconCls: "el-icon-deytpaiming", // 图标样式class
        name: routeName.assessmentItems,//考核项目
        component: assessmentItems,
        children: []
      },
      {
        key: "31-257",
        path: "/assessmentRole",
        iconCls: "el-icon-deytpaiming", // 图标样式class
        name: routeName.assessmentRole,//考核角色
        component: assessmentRole,
        children: []
      },
      {
        key: "31-258",
        path: "/assessmentObject",
        iconCls: "el-icon-deytpaiming", // 图标样式class
        name: routeName.assessmentObject,//考核对象
        component: assessmentObject,
        children: []
      },
      {
        key: "31-259",
        path: "/assessmentDataInput",
        iconCls: "el-icon-deytpaiming", // 图标样式class
        name: routeName.assessmentDataInput,//考核数据录入
        component: assessmentDataInput,
        children: []
      },
      {
        key: "31-260",
        path: "/examinationTableMonth",
        iconCls: "el-icon-deytpaiming", // 图标样式class
        name: routeName.examinationTableMonth,//月度考核表
        component: examinationTableMonth,
        children: []
      },
      {
        key: "31-264",
        path: "/examinationTableYear",
        iconCls: "el-icon-deytpaiming", // 图标样式class
        name: routeName.examinationTableYear,//年度考核表
        component: examinationTableYear,
        children: []
      },
      {
        key: "31-261",
        path: "/monthlyTaskDashboard",
        iconCls: "el-icon-deytpaiming", // 图标样式class
        name: routeName.monthlyTaskDashboard,//月度任务看板
        component: monthlyTaskDashboard,
        children: []
      },
      {
        key: "31-262",
        path: "/annualTaskDashboard",
        iconCls: "el-icon-deytpaiming", // 图标样式class
        name: routeName.annualTaskDashboard,//年度任务看板
        component: annualTaskDashboard,
        children: []
      },
      {
        key: "31-263",
        path: "/performanceStatistics",
        iconCls: "el-icon-deytpaiming", // 图标样式class
        name: routeName.performanceStatistics,//绩效统计
        component: performanceStatistics,
        children: []
      },
    ]
  },
   // 绩效考核end

  {
    key: "2",
    path: "/",
    iconCls: "el-icon-deytxiangmu1", // 图标样式class
    name: routeName.myContract,
    component: Layout,
    children: [
      /*{
        key: "2-5",
        path: "/pending",
        iconCls: "el-icon-deythetong2", // 图标样式class
        name: routeName.pending,//我的合同
        component: pending,
        children: []
      },*/
      {
        key: "2-5",
        path: "/contractIndex",
        iconCls: "el-icon-deythetong2", // 图标样式class
        name: routeName.contractIndex,//我的合同
        component: contractIndex,
        children: []
      },
      {
        key: "2-7",
        path: "/contract",
        iconCls: "el-icon-deytxinxiguanli", // 图标样式class
        name: routeName.contract,
        component: contract,//销售合同列表
        children: []
      },
      {
        key: "2-125",
        path: "/tradeContract",
        iconCls: "el-icon-deythetong3", // 图标样式class
        name: routeName.tradeContract,
        component: tradeContract,//贸易合同列表
        hidden: false,//贸易合同列表
        children: []
      },
      {
        key: "",
        path: "/copyContract/:id",
        iconCls: "el-icon-deytchakanrizhi", // 图标样式class
        name: routeName.copyContract,
        component: copyContract,//复制合同
        children: []
      },
      {
        key: "2-8",
        path: "/contractMould",
        iconCls: "el-icon-deythetong1", // 图标样式class
        name: routeName.contractMould,
        component: contractMould,//合同模板
        children: []
      },
      {
        key: "",
        path: "/newcontract",
        iconCls: "el-icon-deytxinjianwendang", // 图标样式class
        name: routeName.newcontract,//新建合同
        component: newcontract,
        hidden: true,
        children: []
      },
      {
        key: "2-10",
        path: "/newsupply",
        iconCls: "el-icon-deytxinjianmulu", // 图标样式class
        name: routeName.newsupply,//新建补充
        component: newsupply,
        hidden: true,
        children: []
      },
      {
        key: "2-23",
        path: "/adjustmentList",// 调价函列表
        iconCls: "el-icon-deyttiaozhengfeiyong", // 图标样式class
        name: routeName.adjustmentList,//调价函列表
        component: adjustmentList,
        children: []
      },
      {
        key: "2-24",
        path: "/newadjustment",// 新建调价函
        iconCls: "el-icon-deytpiliangtiaojia", // 图标样式class
        name: routeName.newadjustment,//新建调价函
        component: newadjustment,
        hidden: true,
        children: []
      },
      {
        key: "2-5",
        path: "/remind/:name",
        iconCls: "el-icon-deytxinjianmulu", // 图标样式class
        name: routeName.remind,//提醒列表
        component: remind,
        children: []
      },
      {
        key: "2-25",
        path: "/executionClause",// 执行条款
        iconCls: "el-icon-deytfuwutiaokuanjiyinsi", // 图标样式class
        name: routeName.executionClause,//执行条款
        component: executionClause,
        hidden: true,
        children: []
      },
      {
        key: "2-65",
        path: "/transportContractList",// 运输合同列表
        iconCls: "el-icon-deytyunshu-1", // 图标样式class
        name: routeName.transportContractList,//运输合同列表
        component: transportContractList,
        children: []
      },
      {
        key: "2-74",
        path: "/purchaseContract",// 采购合同
        iconCls: "el-icon-deytfuwutiaokuanjiyinsi", // 图标样式class
        name: routeName.purchaseContract,//采购合同
        component: purchaseContract,
        children: []
      }
    ]
  },
  {
    key: "3",
    path: "/",
    iconCls: "el-icon-deyttongji1", // 图标样式class
    name: routeName.dailyListing,
    component: Layout,
    children: [
      {
        key: "3-11",
        path: "/day",
        iconCls: "el-icon-deytcaijingrili", // 图标样式class
        name: routeName.day,//每日挂牌价
        component: day,
        children: []
      },
      {
        key: "3-12",
        path: "/newDaily",
        iconCls: "el-icon-deyttongji", // 图标样式class
        name: routeName.newDaily,//新建挂牌价
        component: newDaily,
        children: []
      },
      {
        key: "3-13",
        path: "/dailyCompute",
        iconCls: "el-icon-deyticon1", // 图标样式class
        name: routeName.dailyCompute,//每日挂牌价计算
        component: dailyCompute,
        children: []
      }
    ]
  },
  {
    key: "5",
    path: "/",
    iconCls: "el-icon-deytxiaoshou-", // 图标样式class
    name: routeName.sell,
    component: Layout,
    children: [
      {
        key: "5-20",
        path: "/mySell",
        iconCls: "el-icon-deytxiaoshoudingdan", // 图标样式class
        name: routeName.mySell,//我的销售单
        component: mySell,
        children: []
      },
      {
        key: "5-16",
        path: "/sellList",
        iconCls: "el-icon-deytxiaoshoudanguanli", // 图标样式class
        name: routeName.sellList,//销售单列表
        component: sellList,
        children: []
      },
      {
        key: "5-89",
        path: "/changeSupplyWay",
        iconCls: "el-icon-deytqiehuan", // 图标样式class
        name: routeName.changeSupplyWay,//切换供货方式
        component: changeSupplyWay,
        children: []
      },
      {
        key: "5-17",
        path: "/innerCheckList",
        iconCls: "el-icon-deytxiaoshoudanju", // 图标样式class
        name: routeName.innerCheckList,//销售单核对
        component: innerCheckList,
        children: []
      },
      {
        key: "5-18",
        path: "/newSellGaugeTicket",
        iconCls: "el-icon-deytnavicon-jldwsz", // 图标样式class
        name: routeName.newSellGaugeTicket,//新建计量单
        component: newSellGaugeTicket,
        children: []
      },
      {
        key: "5-126",
        path: "/meterReading",
        iconCls: "el-icon-deytnavicon-jldw", // 图标样式class
        name: routeName.meterReading,//抄表客户
        component: meterReading,
        children: []
      },
      {
        key: "5-19",
        path: "/sellGaugeTicketList",
        iconCls: "el-icon-deytnavicon-jldw", // 图标样式class
        name: routeName.sellGaugeTicketList,//销售计量单
        component: sellGaugeTicketList,
        children: []
      },
      {
        key: "5-32",
        path: "/errorSellList",
        iconCls: "el-icon-deytrizhiyichang", // 图标样式class
        name: routeName.errorSellList,//异常销售单
        component: errorSellList,
        children: []
      }
    ]
  },
  {
    key: "6",
    path: "/",
    iconCls: "el-icon-deytjiesuantongjibiao", // 图标样式class
    name: routeName.settlement,
    component: Layout,
    children: [
      {
        key: "6-26",
        path: "/mySettlement",
        iconCls: "el-icon-deytfeiyongjiesuandan", // 图标样式class
        name: routeName.mySettlement,//我的结算单
        component: mySettlement,
        children: []
      },
      {
        key: "6-212",
        path: "/oweApplyList",
        iconCls: "el-icon-deytfeiyongjiesuandan", // 图标样式class
        name: routeName.oweApplyList,//欠费申请
        component: oweApplyList,
        children: []
      },
      {
        key: "6-88",
        path: "/otherExpenses",
        iconCls: "el-icon-deytqitafeiyong", // 图标样式class
        name: routeName.otherExpenses,//其他费用审批
        component: otherExpenses,
        children: []
      },
      {
        key: "6-128",
        path: "/receivableList",
        iconCls: "el-icon-deytweb-icon-", // 图标样式class
        name: routeName.receivableList,
        component: receivableList,// 收款项列表
        children: []
      },
      {
        key: "6-27",
        path: "/metering",
        iconCls: "el-icon-deytjiesuandanliebiao", // 图标样式class
        name: routeName.metering,//计量结算单
        component: metering,
        children: []
      },
      {
        key: "6-28",
        path: "/unusualMetering",
        iconCls: "el-icon-deytrizhiyichang", // 图标样式class
        name: routeName.unusualMetering,//异常销售单
        component: unusualMetering,
        children: []
      },
      {
        key: "6-34",
        path: '/beinvoice',
        iconCls: 'el-icon-deytkaipiaoshenqing', // 待开票列表
        name: routeName.beinvoice,
        component: beinvoice,
        children: []
      },
      // {
      //   key: "6-31",
      //   path: "/closingAccounts",
      //   iconCls: "el-icon-deytRectangleCopy2", // 图标样式class
      //   name: routeName.closingAccounts,//销售关账
      //   component: closingAccounts,
      //   children: []
      // },
      {
        key: "6-33",
        path: "/compareData",
        iconCls: "el-icon-deytbijiaofenxi", // 图标样式class
        name: routeName.compareData,//异常单据对比
        component: compareData,
        children: []
      },
    ]
  },
  {
    key: "15",
    path: "/",
    iconCls: "el-icon-deyttongji1", // 图标样式class
    name: routeName.innerCash,
    component: Layout,
    children: [
      {
        key: "15-154",
        path: "/companyPolicy",
        iconCls: "el-icon-deytcaijingrili", // 图标样式class
        name: routeName.companyPolicy,//公司政策
        component: companyPolicy,
        children: []
      },
      {
        key: "15-104",
        path: "/purchasePrice",
        iconCls: "el-icon-deytcaijingrili", // 图标样式class
        name: routeName.purchasePrice,//内部挂牌价
        component: purchasePrice,
        children: []
      },
      {
        key: "15-98",
        path: "/groupPurchase",
        iconCls: "el-icon-deytjituanxinwen", // 图标样式class
        name: routeName.groupPurchase,//集团采购计划
        component: groupPurchase,
        children: []
      },
      {
        key: "15-112",
        path: "/standardFreightList",
        iconCls: "el-icon-deytyunshu-", // 图标样式class
        name: routeName.standardFreightList,// 基准运费
        component: standardFreightList,
        children: []
      },
      {
        key: "15-99",
        path: "/innerPriceHistoryList",
        iconCls: "el-icon-deytjiagebiao", // 图标样式class
        name: routeName.innerPriceHistoryList,// 内部挂牌价历史
        component: innerPriceHistoryList,
        children: []
      },
      {
        key: "15-217",
        path: "/lCngChargeList",
        iconCls: "el-icon-deytjiagebiao", // 图标样式class
        name: routeName.lCngChargeList,// 内部挂牌价历史
        component: lCngChargeList,
        children: []
      },
    ]
  },
  {
    key: "15",
    path: "/",
    iconCls: "el-icon-deytcaigouguanli", // 图标样式class
    name: routeName.myPurchase,
    component: Layout,
    children: [
      {
        key: "15-85",
        path: "/mypurchasel",
        iconCls: "el-icon-deytcaigouliangduibi", // 图标样式class
        name: routeName.mypurchasel,//我的采购
        component: mypurchasel,
        children: []
      },
      {
        key: "15-122",
        path: "/subcompanyPlan",
        iconCls: "el-icon-deytcaigoushenqing1", // 图标样式class
        name: routeName.subcompanyPlan, // 子公司上报采购计划
        component: subcompanyPlan,
        children: []
      },
      {
        key: "15-123",
        path: "/arrangePurchasingPlan",
        iconCls: "el-icon-deytcaigoudingdan-", // 图标样式class
        name: routeName.arrangePurchasingPlan, // 总公司安排采购计划
        component: arrangePurchasingPlan,
        children: []
      },
      {
        key: "15-124",
        path: "/batchConfirm",
        iconCls: "el-icon-deytcaigoushenqing", // 图标样式class
        name: routeName.batchConfirm, // 确认用气计划
        component: batchConfirm,
        children: []
      },
      {
        key: "15-82",
        path: "/preferentialClause",
        iconCls: "el-icon-deytcaigoushenqing", // 图标样式class
        name: routeName.preferentialClauseList, // 优惠条款
        component: preferentialClauseList,
        children: []
      },
      {
        key: "15-83",
        path: "/priceConfirmList",
        iconCls: "el-icon-deytcaigoushenqing", // 图标样式class
        name: routeName.priceConfirmList, // 价格确认函
        component: priceConfirmList,
        children: []
      },
      {
        key: "15-76",
        path: "/purchaseList",
        iconCls: "el-icon-deytcaigoushenqing", // 图标样式class
        name: routeName.purchaseList, // 采购单
        component: purchaseList,
        children: []
      },
      {
        key: "15-79",
        path: "/changeSettleAmountList",
        iconCls: "el-icon-deytcaigoushenqing", // 图标样式class
        name: routeName.changeSettleAmountList, // 修改结算量
        component: changeSettleAmountList,
        children: []
      },
      {
        key: "15-80",
        path: "/checkAmount",
        iconCls: "el-icon-deytnavicon-cgzb", // 图标样式class
        name: routeName.checkAmount,//采购对量单
        component: checkAmount,
        children: []
      },
      {
        key: "15-81",
        path: "/purchasePay",
        iconCls: "el-icon-deytnavicon-cgzb", // 图标样式class
        name: routeName.purchasePay,//采购付款项
        component: purchasePay,
        children: []
      },
      {
        key: "15-77",
        path: "/purchaseSettle",
        iconCls: "el-icon-deytnavicon-cgzb", // 图标样式class
        name: routeName.purchaseSettle,//采购单结算
        component: purchaseSettle,
        children: []
      },
      {
        key: "15-227",
        path: "/gasUseAndPrice",
        name: routeName.gasUseAndPrice,// 南通扬州用气量和价格配置
        component: gasUseAndPrice,
        children: []
      },
      {
        key: "15-229",
        path: "/lngInOutBase",
        name: routeName.lngInOutBase,// 南通扬州用气量和价格配置
        component: lngInOutBase,
        children: []
      },
      // {
      //   key: "15-78",
      //   path: "/orderinvoice",
      //   iconCls: "el-icon-deytcaigoufapiao", // 图标样式class
      //   name: routeName.orderinvoice,//采购收票
      //   component: orderinvoice,
      //   children: []
      // },
      // {
      //   key: "15-79",
      //   path: "/orderaccount",
      //   iconCls: "el-icon-deytcaigoujihua", // 图标样式class
      //   name: routeName.orderaccount,//采购关账
      //   component: orderaccount,
      //   children: []
      // },
      // {
      //   key: "15-80",
      //   path: "/orderform",
      //   iconCls: "el-icon-deytcaigoubaobiao", // 图标样式class
      //   name: routeName.orderform,//采购报表
      //   component: orderform,
      //   children: []
      // },
      // {
      //   key: "15-81",
      //   path: "/supplierbuget",
      //   iconCls: "el-icon-deytyusuanqijian", // 图标样式class
      //   name: routeName.supplierbuget,//供应商预算
      //   component: supplierbuget,
      //   children: []
      // },
      // {
      //   key: "15-82",
      //   path: "/paybuget",
      //   iconCls: "el-icon-deytyusuanyuchengbenguanli", // 图标样式class
      //   name: routeName.paybuget,//付款单位预算
      //   component: paybuget,
      //   children: []
      // },
      // {
      //   key: "15-83",
      //   path: "/adjustPrice",
      //   iconCls: "el-icon-deyttiaojiaadjust", // 图标样式class
      //   name: routeName.adjustPrice,//调差管理
      //   component: adjustPrice,
      //   children: []
      // }
    ]
  },
  {
    key: "14",
    path: "/",
    iconCls: "el-icon-deytyunshu-", // 图标样式class
    name: routeName.transport,
    component: Layout,
    children: [
      {
        key: "14-90",
        path: "/myTransport",
        iconCls: "el-icon-deytziyuan1", // 图标样式class
        name: routeName.myTransport,// 我的运输单
        component: myTransport,
        children: []
      },
      {
        key: "14-66",
        path: "/taskList",
        iconCls: "el-icon-deytrenwudanguanli", // 图标样式class
        name: routeName.taskList,//任务单列表
        component: taskList,
        children: []
      },
      // {
      //   key: "14-66",
      //   path: "/newTrance",
      //   iconCls: "el-icon-deytyunshu-", // 图标样式class
      //   name: routeName.newTrance,//新建集装格任务单
      //   component: newTrance,
      //   children: []
      // },
      {
        key: "",
        hidden: true,
        path: "/newTransport",
        iconCls: "el-icon-deytyunshu-", // 图标样式class
        name: routeName.newTransport,//新建运输单
        component: newTransport,
        children: []
      },
      {
        key: "14-67",
        path: "/transportList",
        iconCls: "el-icon-deytyunshu-", // 图标样式class
        name: routeName.transportList,//运输单列表
        component: transportList,
        children: []
      },
      {
        key: "14-68",
        path: "/transportCheckList",
        iconCls: "el-icon-deythedui", // 图标样式class
        name: routeName.transportCheckList,//运输单核对列表
        component: transportCheckList,
        children: []
      },
      {
        key: "14-69",
        path: "/checkAmountList",
        iconCls: "el-icon-deythedui1", // 图标样式class
        name: routeName.checkAmountList,//运输对量列表
        component: checkAmountList,
        children: []
      },
      {
        key: "14-155",
        path: "/transportPay",
        iconCls: "el-icon-deytqian4", // 图标样式class
        name: routeName.transportPay,//运输付款项列表
        component: transportPay,
        children: []
      },
      {
        key: "14-70",
        path: "/checkMoneyList",
        iconCls: "el-icon-deytqian4", // 图标样式class
        name: routeName.checkMoneyList,//运输结算列表
        component: checkMoneyList,
        children: []
      },
      {
        key: "14-156",
        path: "/tollList",
        iconCls: "el-icon-deytqian4", // 图标样式class
        name: routeName.tollList,//运输通行费列表
        component: tollList,
        children: []
      },
      {
        key: "14-157",
        path: "/saturation",
        iconCls: "el-icon-deytqian4", // 图标样式class
        name: routeName.saturation,//运输饱和度列表
        component: saturation,
        children: []
      },
      {
        path: "/saturationprint",
        component: saturationprint,
        name: "saturationprint",
        hidden: true,
        children: []
      },
      {
        path: "/saturationDetailPrint",
        component: saturationDetailPrint,
        name: "saturationDetailPrint",
        hidden: true,
        children: []
      },
      {
        key: "14-57",
        path: "/driverList",
        iconCls: "el-icon-deyttubiaozhizuomoban-127", // 图标样式class
        name: routeName.driverList,
        component: driverList,//驾押员列表
        children: []
      },
      {
        key: "14-58",
        path: "/carTypeList",
        iconCls: "el-icon-deytchexing", // 图标样式class
        name: routeName.carTypeList,
        component: carTypeList,// 车型列表
        children: []
      },
      {
        key: "14-59",
        path: "/carSet",
        iconCls: "el-icon-deytchexingluntan", // 图标样式class
        name: routeName.carSet,
        component: carSet,// 车辆配置
        children: []
      },
      {
        key: "14-60",
        path: "/ETCList",
        iconCls: "el-icon-deytetc", // 图标样式class
        name: routeName.ETCList,
        component: ETCList,// ETC列表
        children: []
      },
      {
        key: "",
        hidden: true,
        path: "/ETCTradeList",
        iconCls: "el-icon-deytETCzhangdan", // 图标样式class
        name: routeName.ETCTradeList,
        component: ETCTradeList,// ETC交易列表
        children: []
      },
      {
        key: "14-61",
        path: "/fuelCardList",
        iconCls: "el-icon-deytyouka", // 图标样式class
        name: routeName.fuelCardList,
        component: fuelCardList,// 油卡列表
        children: []
      },
      {
        key: "",
        hidden: true,
        path: "/fuelCardTradeList",
        iconCls: "el-icon-deytweibiaoti2fuzhi18", // 图标样式class
        name: routeName.fuelCardTradeList,
        component: fuelCardTradeList,// 油卡交易列表
        children: []
      },
      {
        key: "14-127",
        path: "/distanceList",
        iconCls: "el-icon-deytqitafeiyong1", // 图标样式class
        name: routeName.distanceList,
        component: distanceList,// 距离管理列表
        children: []
      },
      {
        key: "14-62",
        path: "/otherFeeList",
        iconCls: "el-icon-deytqitafeiyong1", // 图标样式class
        name: routeName.otherFeeList,
        component: otherFeeList,// 其他费用列表
        children: []
      },
      {
        key: "14-63",
        path: "/gasPriceList",
        iconCls: "el-icon-deytweb-icon-", // 图标样式class
        name: routeName.gasPriceList,
        component: gasPriceList,// 油价列表
        children: []
      },
      {
        key: "14-64",
        path: "/oilPriceList",
        iconCls: "el-icon-deytyoudi", // 图标样式class
        name: routeName.oilPriceList,
        component: oilPriceList,// 运输油价列表
        children: []
      },
      {
        key: "14-91",
        path: "/loadUnloadList",
        iconCls: "el-icon-deytzhuangxiedanguanli", // 图标样式class
        name: routeName.loadUnloadList,
        component: loadUnloadList,// 运输装卸单列表
        children: []
      },
      {
        key: "14-92",
        path: "/familyFeeList",
        iconCls: "el-icon-deytcheliangfeiyong", // 图标样式class
        name: routeName.familyFeeList,
        component: familyFeeList,// 运输家次费列表
        children: []
      },
      {
        key: "14-93",
        path: "/gasPriceComputer",
        iconCls: "el-icon-deytjisuanqi", // 图标样式class
        name: routeName.gasPriceComputer,
        component: gasPriceComputer,// 气量运输单价计算器
        children: []
      },
      {
        key: "14-94",
        path: "/carTransportReport",
        iconCls: "el-icon-deytcheliangtongji", // 图标样式class
        name: routeName.carTransportReport,
        component: carTransportReport,// 车辆运输统计
        children: []
      },
      {
        key: "14-95",
        path: "/twoInvoiceTransportReport",
        iconCls: "el-icon-deytcheliangtongji1", // 图标样式class
        name: routeName.twoInvoiceTransportReport,
        component: twoInvoiceTransportReport,// 两票制运费查询
        children: []
      },
      {
        key: "14-96",
        path: "/transportCheckReport",
        iconCls: "el-icon-deytjianchazhan-chelianghecha", // 图标样式class
        name: routeName.transportCheckReport,
        component: transportCheckReport,// 运输单核查
        children: []
      },
      {
        key: "14-97",
        path: "/errorTransportList",
        iconCls: "el-icon-deytrenkou--", // 图标样式class
        name: routeName.errorTransportList,
        component: errorTransportList,// 异常运输单
        children: []
      }
      ]
  },
  /*
  {
    path: "/riskControl",
    iconCls: "fa fa-exclamation-triangle", // 图标样式class
    name: routeName.riskControl,
    component: Layout,
    alone: true,
    children: [
      {
        path: "/riskControl",
        iconCls: "fa fa-exclamation-triangle", // 图标样式class
        name: routeName.riskControl,
        component: riskControl,
        children: []
      }
    ]
  },
*/
  {
    key: "13",
    path: "/",
    iconCls: "el-icon-deyttrade", // 图标样式class
    name: routeName.trade,
    component: Layout,
    children: [
      {
        key: "13-55",
        path: "/riskControl",
        iconCls: "fa fa-exclamation-triangle", // 图标样式class
        name: routeName.riskControl,
        component: riskControl,//风控看板
        children: []
      },
      {
        key: "13-56",
        path: "/collectionList",
        iconCls: "el-icon-deytyingshouyingfu", // 图标样式class
        name: routeName.collectionList,//实时印绶
        component: collectionList,
        children: []
      },
      /*{
        key: "13-105",
        path: "/tradeRuleList",
        iconCls: "el-icon-deytguize", // 图标样式class
        name: routeName.tradeRuleList,//贸易规则
        component: tradeRuleList,
        children: []
      },*/
      {
        key: "13-106",
        path: "/tradeCustomerList",
        iconCls: "el-icon-deytkehu", // 图标样式class
        name: routeName.tradeCustomerList,//贸易客户
        component: tradeCustomerList,
        children: []
      },
      /*{
        key: "14-66",
        path: "/myTrade",
        iconCls: "el-icon-deytshuju1", // 图标样式class
        name: routeName.myTrade,//我的贸易
        hidden: true,
        component: myTrade,
        children: []
      },*/
      /*{
        key: "13-56",
        path: "/tradeContractList",
        iconCls: "el-icon-deytfeiyongjiesuandan", // 图标样式class
        name: routeName.tradeContractList,//贸易合同
        component: tradeContractList,
        children: []
      },*/
      {
        key: "13-107",
        path: "/tradeDemand",
        iconCls: "el-icon-deytxuqiudengji", // 图标样式class
        name: routeName.tradeDemand,//贸易需求单
        component: tradeDemand,
        children: []
      },
      {
        key: "13-108",
        path: "/priceConfirm",
        iconCls: "el-icon-deytjiagebiao", // 图标样式class
        name: routeName.priceConfirm,//价格确认函
        component: priceConfirm,
        children: []
      },
      {
        key: "13-109",
        path: "/tradeSale",
        iconCls: "el-icon-deytxiaoshoudingdan", // 图标样式class
        name: routeName.tradeSale,//贸易销售单
        component: tradeSale,
        children: []
      },
      {
        key: "13-183",
        path: "/tradeCheckAmount",
        iconCls: "el-icon-deytxiaoshoudingdan", // 图标样式class
        name: routeName.tradeCheckAmount,//贸易对量
        component: tradeCheckAmount,
        children: []
      },
      {
        key: "13-184",
        path: "/tradeCollection",
        iconCls: "el-icon-deytxiaoshoudingdan", // 图标样式class
        name: routeName.tradeCollection,//贸易收款项
        component: tradeCollection,
        children: []
      },
      {
        key: "13-110",
        path: "/tradeSettle",
        iconCls: "el-icon-deytfeiyongjiesuandan", // 图标样式class
        name: routeName.tradeSettle,//贸易结算单
        component: tradeSettle,
        children: []
      },
    ]
  },
  {
    key: "13",
    path: "/",
    iconCls: "el-icon-deyttrade", // 图标样式class
    name: routeName.tradeProfit,
    component: Layout,
    hidden:true,
    children: [
      {
        key: "13-55",
        path: "/profitStatistics",
        iconCls: "fa fa-exclamation-triangle", // 图标样式class
        name: routeName.profitStatistics,
        component: profitStatistics,//风控看板
        children: []
      },
      {
        key: "13-55",
        path: "/profitRule",
        iconCls: "fa fa-exclamation-triangle", // 图标样式class
        name: routeName.profitRule,
        component: profitRule,//风控看板
        children: []
      },
      {
        key: "13-55",
        path: "/customerRebate",
        iconCls: "fa fa-exclamation-triangle", // 图标样式class
        name: routeName.customerRebate,
        component: customerRebate,//风控看板
        children: []
      },
      {
        key: "13-55",
        path: "/businessBx",
        iconCls: "fa fa-exclamation-triangle", // 图标样式class
        name: routeName.businessBx,
        component: businessBx,//风控看板
        children: []
      },
      {
        key: "13-55",
        path: "/rewardRuleList",
        iconCls: "fa fa-exclamation-triangle", // 图标样式class
        name: routeName.rewardRuleList,
        component: rewardRuleList,//风控看板
        children: []
      },
      {
        key: "13-55",
        path: "/awardIssueRuleList",
        iconCls: "fa fa-exclamation-triangle", // 图标样式class
        name: routeName.awardIssueRuleList,
        component: awardIssueRuleList,//风控看板
        children: []
      },
      {
        key: "13-55",
        path: "/staffRoleList",
        iconCls: "fa fa-exclamation-triangle", // 图标样式class
        name: routeName.staffRoleList,
        component: staffRoleList,//风控看板
        children: []
      },
      {
        key: "13-55",
        path: "/salesRewardDetailList",
        iconCls: "fa fa-exclamation-triangle", // 图标样式class
        name: routeName.salesRewardDetailList,
        component: salesRewardDetailList,//风控看板
        children: []
      },
      {
        key: "13-55",
        path: "/otherRewardDetailList",
        iconCls: "fa fa-exclamation-triangle", // 图标样式class
        name: routeName.otherRewardDetailList,
        component: otherRewardDetailList,//风控看板
        children: []
      },
      {
        key: "13-55",
        path: "/awardIssueDetailList",
        iconCls: "fa fa-exclamation-triangle", // 图标样式class
        name: routeName.awardIssueDetailList,
        component: awardIssueDetailList,//风控看板
        children: []
      },
    ]
  },
  /*气款管理 start*/
  {
    key: "30",
    path: "/",
    iconCls: "el-icon-deytcaigoushenqing", // 气款管理
    name: routeName.gasManagement,
    component: Layout,
    children: [
      {
        key: "30-247",
        path: "/gasPaymentApplication",
        name: routeName.gasPaymentApplication,
        component: gasPaymentApplication,//气款申请单
        children: []
      },
    ]
  },
  /*气款管理 end*/
  /*资金管理*/
  {
    key: "17",
    path: "/",
    iconCls: "el-icon-deytfapiaoguanli_icox", // 财务管理
    name: routeName.invoiceMag,
    component: Layout,
    children: [
      {
        key: "17-167",
        path: "/myReceiveAndPay",
        name: routeName.myReceiveAndPay,
        component: myReceiveAndPay,//我的应收应付
        children: []
      },
      {
        key: "17-132",
        path: "/invoiceApply",
        name: routeName.invoiceApply,
        component: invoiceApply,//发票申领
        children: []
      },
      {
        key: "17-29",
        path: "/invoice",
        iconCls: "el-icon-deytfapiaoguanli1", // 图标样式class
        name: routeName.invoice,//开票列表
        component: invoice,
        children: []
      },
      {
        key: "17-133",
        path: "/invoiceNew",
        name: routeName.invoiceNew,
        component: invoiceNew,//发票管理
        children: []
      },
      {
        key: "17-168",
        path: "/beReceiveInvoice",
        name: routeName.beReceiveInvoice,
        component: beReceiveInvoice,//待收票列表
        children: []
      },
      /*这个去掉了，不要冲掉*/
      /*{
        key: "17-169",
        path: "/needPayTax",
        name: routeName.needPayTax,
        component: needPayTax,//应交增值税
        children: []
      },*/
      {
        key: "17-170",
        path: "/supplyNeedPay",
        name: routeName.supplyNeedPay,
        component: supplyNeedPay,//供应商应付
        children: []
      },
      {
        key: "17-171",
        path: "/transportNeedPay",
        name: routeName.transportNeedPay,
        component: transportNeedPay,//运输应付
        children: []
      },
      {
        key: "17-172",
        path: "/curstomerNeedReceive",
        name: routeName.curstomerNeedReceive,
        component: curstomerNeedReceive,//客户应收
        children: []
      },
      {
        key: "17-173",
        path: "/purchaseEstimate",
        name: routeName.purchaseEstimate,
        component: purchaseEstimate,//采购暂估
        children: []
      },
      {
        key: "17-174",
        path: "/sellEstimate",
        name: routeName.sellEstimate,
        component: sellEstimate,//销售暂估
        children: []
      },
      {
        key: "17-205",
        path: "/transportEstimate",
        name: routeName.transportEstimate,
        component: transportEstimate,//运输暂估
        children: []
      },
      {
        key: "17-175",
        path: "/purchaseStand",
        name: routeName.purchaseStand,
        component: purchaseStand,//采购台账
        children: []
      },
      {
        key: "17-176",
        path: "/sellStand",
        name: routeName.sellStand,
        component: sellStand,//销售台账
        children: []
      },
      {
        key: "17-177",
        path: "/transportStand",
        name: routeName.transportStand,
        component: transportStand,//运输台账
        children: []
      },
      {
        key: "17-178",
        path: "/purchaseReport",
        name: routeName.purchaseReport,
        component: purchaseReport,//采购报表
        children: []
      },
      {
        key: "17-179",
        path: "/sellReport",
        name: routeName.sellReport,
        component: sellReport,//销售报表
        children: []
      },
      {
        key: "17-180",
        path: "/transportReport",
        name: routeName.transportReport,
        component: transportReport,//运输报表
        children: []
      },
      {
        key: "17-181",
        path: "/closingAcount",
        name: routeName.closingAcount,
        component: closingAcount,//关账
        children: []
      },
      {
        key: "17-248",
        path: "/estimatedCost",
        name: routeName.estimatedCost,
        component: estimatedCost,//预算费用
        children: []
      },
    ]
    },
    {
      key: "26",
      path: "/",
      iconCls: "el-icon-deytqitafeiyong", // 利润分析
      name: routeName.profitability,
      component: Layout,
      children: [
        {
          key: "26-200",
          path: "/fixedAssets",
          name: routeName.fixedAssets,
          component: fixedAssets,//固定资产
          children: []
        },
        {
          key:"26-201",
          path:"/ratioAnalysis",
          name:routeName.ratioAnalysis,
          component:ratioAnalysis,//成本系数
          children:[]
        },
        {
          key:"26-202",
          path:"/manageRate",
          name:routeName.manageRate,
          component:manageRate,//管理费率
          children:[]
        },
        {
          key: "26-214",
          path: "/pointCost",
          name: routeName.pointCost,
          component: pointCost,//交割点成本
          children: []
        },
        {
          key:"26-203",
          path:"/benefitsList",
          name:routeName.benefitsList,
          component:benefitsList,//利润分析
          children:[]
        },
        {
          key:"26-204",
          path:"/projectBenefits",
          name:routeName.projectBenefits,
          component:projectBenefits,//项目利润分析
          children:[]
        }
      ]
    },
  {
    key: "18",
    path: "/",
    iconCls: "el-icon-deytqian4", // 资金管理
    name: routeName.fundMag,
    component: Layout,
    children: [
      {
        key: "18-208",
        path: "/virtualAccount",
        name: routeName.virtualAccount,
        component: virtualAccount,//客户虚拟户
        children: []
      },
      {
        key: "18-209",
        path: "/transferVirtual",
        name: routeName.transferVirtual,
        component: transferVirtual,//虚拟户交易列表
        children: []
      },
      {
        key: "18-139",
        path: "/accountBalance",
        name: routeName.accountBalance,
        component: accountBalance,//账户余额
        children: []
      },
      {
        key: "18-140",
        path: "/circleStartBalance",
        name: routeName.circleStartBalance,
        component: circleStartBalance,//期初余额
        children: []
      },
      {
        key: "18-141",
        path: "/receiveMoney",
        name: routeName.receiveMoney,
        component: receiveMoney,//收款查询
        children: []
      },
      {
        key: "18-142",
        path: "/payMoney",
        name: routeName.payMoney,
        component: payMoney,//付款查询
        children: []
      },
      {
        key: "18-134",
        path: "/subject",
        name: routeName.subject,
        component: subject,//会计科目
        children: []
      },
      {
        key: "18-135",
        path: "/draft",
        name: routeName.draft,
        component: draft,//承兑汇票
        children: []
      },
      {
        key: "18-136",
        path: "/draftCollect",
        name: routeName.draftCollect,
        component: draftCollect,//承兑汇票托收列表
        children: []
      },
      {
        key: "18-191",
        path: "/discount",
        name: routeName.discount,
        component: discount,//承兑汇票贴现列表
        children: []
      },
      {
        key: "18-137",
        path: "/transferOrder",
        name: routeName.transferOrder,
        component: transferOrder,//资金往来
        children: []
      },
      {
        key: "18-138",
        path: "/payApproveOrder",
        name: routeName.payApproveOrder,
        component: payApproveOrder,//付款申请
        children: []
      },
    ]
  },
  /*报销管理start*/
  {
    key: "28",
    path: "/",
    iconCls: "el-icon-deytbaoxiaoguanli", // 报销管理
    name: routeName.reimburse,
    component: Layout,
    children: [
      {
        key: "28-233",
        path: "/reimbursementType",
        name: routeName.reimbursementType,
        component: reimbursementType,//报销类型
        children: []
      },
      {
        key: "28-234",
        path: "/reimburseManagement",
        name: routeName.reimburseManagement,
        component: reimburseManagement,//报销单
        children: []
      },
      {
        key: "28-236",
        path: "/indexStaff",
        name: routeName.indexStaff,
        component: indexStaff,//报销单填报
        children: []
      },
      {
        key: "28-235",
        path: "/reimbursementSummary",
        name: routeName.reimbursementSummary,
        component: reimbursementSummary,//报销汇总
        children: []
      },
      {
        key: "28-237",
        path: "/reimbursementStatistics",
        name: routeName.reimbursementStatistics,
        component: reimbursementStatistics,//报销统计
        children: []
      },
    ]
  },
  /*报销管理end*/
  // 工资管理start
  {
    key: "29",
    path: "/",
    iconCls: "el-icon-deytyusuanyuchengbenguanli", // 工资管理
    name: routeName.salaryManagement,
    component: Layout,
    children: [
      {
        key: "29-238",
        path: "/individualIncomeTaxLevel",
        name: routeName.individualIncomeTaxLevel,
        component: individualIncomeTaxLevel,//个税等级
        children: []
      },
      {
        key: "29-239",
        path: "/floatingSalaryType",
        name: routeName.floatingSalaryType,
        component: floatingSalaryType,//浮动工资类型
        children: []
      },
      {
        key: "29-240",
        path: "/socialSecurityInformation",
        name: routeName.socialSecurityInformation,
        component: socialSecurityInformation,//社保信息
        children: []
      },
      {
        key: "29-241",
        path: "/personnelSalaryInformation",
        name: routeName.personnelSalaryInformation,
        component: personnelSalaryInformation,//人员工资信息
        children: []
      },
      {
        key: "29-242",
        path: "/floatingSalary",
        name: routeName.floatingSalary,
        component: floatingSalary,//浮动工资
        children: []
      },
      {
        key: "29-243",
        path: "/salaryDetails",
        name: routeName.salaryDetails,
        component: salaryDetails,//工资明细
        children: []
      },
      {
        key: "29-244",
        path: "/salaryAdjustment",
        name: routeName.salaryAdjustment,
        component: salaryAdjustment,//工资调差
        children: []
      },
      {
        key: "29-245",
        path: "/salarySummary",
        name: routeName.salarySummary,
        component: salarySummary,//工资汇总
        children: []
      },
      {
        key: "29-246",
        path: "/attendanceSummary",
        name: routeName.attendanceSummary,
        component: attendanceSummary,//考勤汇总
        children: []
      },
    ]
  },
  {
    key: "22",
    path: "/",
    iconCls: "el-icon-deytcaigouguanli", // 工具箱
    name: routeName.tools,
    component: Layout,
    children: [
      {
        key: "22-166",
        path: "/LNGProposal",
        name: routeName.LNGProposal,
        component: LNGProposal,
        children: []
      },
      {
        key: "22-185",
        path: "/newBattlePlan",
        name: routeName.newBattlePlan,
        component: newBattlePlan,
        children: []
      },
      {
        key: "22-186",
        path: "/planOther",
        name: routeName.statisticsPlan,
        component:newBattlePlan,
        children: []
      },

    ]
  },
  /*cylinder 钢瓶管理*/
  {
    key: "23",
    path: "/",
    iconCls: "el-icon-deytqitigangping", // 工具箱
    name: routeName.cylinder,
    component: Layout,
    children: [
      {
        key: "23-190",
        path: "/scanRecord",
        name: routeName.scanRecord,
        component: scanRecord,
        children: []
      },
      {
        key: "23-196",
        path: "/truckRecord",
        name: routeName.truckRecord,
        component: truckRecord,
        children: []
      },
      {
        key: "23-188",
        path: "/cylinderList",
        name: routeName.cylinderList,
        component: cylinderList,
        children: []
      },
      {
        key: "23-187",
        path: "/cylinderTagList",
        name: routeName.cylinderTagList,
        component: cylinderTagList,
        children: []
      },
      {
        key: "23-189",
        path: "/cylinderContainer",
        name: routeName.cylinderContainer,
        component: cylinderContainer,
        children: []
      },
      {
        key: "23-192",
        path: "/cylindermanage",
        name: routeName.cylindermanage,
        component: cylindermanage,//往来账户
        children: []
      },
    ]
  },
  /*充装*/
  {
    key: "24",
    path: "/",
    iconCls: "el-icon-deytweibiaoti2fuzhi18", // 充装
    name: routeName.charge,
    component: Layout,
    children: [
      {
        key: "24-193",
        path: "/chargeList",
        name: routeName.chargeList,
        component: chargeList,
        children: []
      },
      {
        key: "24-194",
        path: "/checkChargeList",
        name: routeName.checkChargeList,
        component: checkChargeList,
        children: []
      },
    ]
  },
  /*统计报表*/
  {
    key: "25",
    path: "/",
    iconCls: "el-icon-deyttongji", // 应收账目周统计
    name: routeName.statics,
    component: Layout,
    children: [
      {
        key: "25-197",
        path: "/weeklyCollectionStaticsList",
        name: routeName.weeklyCollectionStaticsList,
        component: weeklyCollectionStaticsList,
        children: []
      },
      {
        key: "25-207",
        path: "/cngReport",
        name: routeName.cngReport,
        component: cngReport,
        children: []
      },
      {
        key: "25-210",
        path: "/lngReport",
        name: routeName.lngReport,
        component: lngReport,
        children: []
      },
    ]
  },
  /*其他业务*/
  {
    key: "27",
    path: "/",
    iconCls: "el-icon-deytqiehuan",
    name: routeName.otherBusiness,
    component: Layout,
    children: [
      {
        key: "27-211",
        path: "/circulationList",
        name: routeName.circulationList,// 流转
        component: circulationList,
        children: []
      },
      {
        key: "27-211",
        path: "/circulationAdd",
        name: routeName.circulationAdd,// 新增流转
        component: circulationAdd,
        children: []
      },
      {
        key: "27-216",
        path: "/specialProcessPurchaseList",
        name: routeName.specialProcessPurchaseList,// 非标流程采购
        component: specialProcessPurchaseList,
        children: []
      },
    ]
  },



];
const $router = new Router({
  routes: defaultRouter
});
$router.onReady(vm => {

  try {
    let LoadingChunkPath = window.sessionStorage.getItem('LoadingChunkPath');
    const path = vm.path;
    if (LoadingChunkPath) {
      if (path !== LoadingChunkPath && path !== '/') {
        window.sessionStorage.setItem('LoadingChunkPath', vm.path);
        $router.replace(vm.path);
      } else {
        $router.replace(LoadingChunkPath);
      }
    }
  } catch (e) {
    console.log(e);
  }
});
$router.onError((err) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = err.message.match(pattern);
  if (isChunkLoadFailed) {
    let chunkBool = sessionStorage.getItem('chunkError');
    let nowTimes = Date.now();
    if (chunkBool === null || chunkBool && nowTimes - parseInt(chunkBool) > 60000) {//路由跳转报错,href手动跳转
      sessionStorage.setItem('chunkError', 'reload');
      const targetPath = $router.history.pending.fullPath;
      window.location.href = window.location.origin + targetPath;
    }else if(chunkBool === 'reload'){ //手动跳转后依然报错,强制刷新
      sessionStorage.setItem('chunkError', Date.now());
      window.location.reload(true);
    }
  }
})

// 解决Loading chunk (\d)+ failed问题
// $router.onError((error) => {
//   // way 1
//   // const pattern = /Loading chunk (\d)+ failed/g;
//   // const isChunkLoadFailed = error.message.match(pattern);
//   // const targetPath = $router.history.pending.fullPath;
//   // if (isChunkLoadFailed) {
//   //   location.reload();
//   //   // $router.replace(targetPath);
//   // }
//
//   // way 2
//   const pattern = /Loading chunk (\d)+ failed/g;
//   const isChunkLoadFailed = error.message.match(pattern);
//   const targetPath = $router.history.pending.fullPath;
//   try {
//     if (isChunkLoadFailed) {
//       let LoadingChunk = window.sessionStorage.getItem('LoadingChunk');
//       if (LoadingChunk) {
//         window.sessionStorage.setItem('LoadingChunk', LoadingChunk - 0 + 1);
//       } else {
//         window.sessionStorage.setItem('LoadingChunk', 1);
//       }
//       if (LoadingChunk - 0 > 1) {
//         // 防止 死循环
//         return false;
//       }
//       $router.replace(targetPath);
//       window.sessionStorage.setItem('LoadingChunkPath', targetPath);
//       const sa = window.sa;
//       if (sa && sa.track) {
//         sa.track('element_click', {
//           page_title: 'LoadingChunk',
//           element_type: 'view',
//           page_source: targetPath, // 当前路由
//           element_name: `刷新页面${LoadingChunk - 0}次` // 尝试 打开次数
//         });
//       }
//     }
//   } catch (e) {
//     consolee.log('路由报错啦啦啦啦啦！！！！')
//     console.log(e);
//   }
// })





export default $router;
export { defaultRouter, addRouter};



// WEBPACK FOOTER //
// ./src/router/index.js